module.exports = __webpack_public_path__ + "static/img/detail-meetingD.a6068158.png";